// Meta Pixel loader + event helpers.
// Stays completely inert until REACT_APP_META_PIXEL_ID is set in frontend/.env.

let loaded = false;

export function isPixelEnabled() {
  return !!process.env.REACT_APP_META_PIXEL_ID;
}

export function initMetaPixel() {
  const id = process.env.REACT_APP_META_PIXEL_ID;
  if (!id || loaded || typeof window === "undefined") return;

  /* Meta Pixel base code */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod
        ? n.callMethod.apply(n, arguments)
        : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(
    window,
    document,
    "script",
    "https://connect.facebook.net/en_US/fbevents.js"
  );

  window.fbq("init", id);
  loaded = true;
}

export function trackEvent(name, params) {
  if (typeof window !== "undefined" && window.fbq) {
    window.fbq("track", name, params || {});
  }
}
